var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.ready && _vm.$store.state.currencies.length)?_c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('router-view'),_c('div'),(_vm.showPremiumButton)?_c('PremiumButton'):_vm._e(),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }